<template>
  <back-office-list
    :title="this.$t('common.casinos')"
    :has-add-button="true"
    :add-button-caption="this.$t('casinos.add')"
    :loading="casinosMeta.loading"
    :list-data="casinos"
    route-to-add-page="add-casino"
    :selection-change="handleSelectionChange"
    :columns="columns"
  />
</template>

<script>
  import BackOfficeList from '@/components/BackOfficeList'
  import { useCasinos } from './casinoHooks'

  export default {
    name: 'Casinos',
    components: { BackOfficeList },
    mixins: [
      useCasinos('casinos')
    ],
    methods: {
      handleSelectionChange (casino) {
        this.$router.push({ name: 'edit-casino', params: { id: casino.id } })
      },
      handlePush (casino, event) {
        event.stopPropagation()
        this.$router.push({ name: 'push-casino', params: { id: casino.id } })
      }
    },
    computed: {
      columns () {
        return [
          {
            header: this.$t('common.name'),
            field: 'name',
          },
        ]
      },
    },
  }
</script>

<style
  lang="scss"
  scoped
>
</style>
